import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
import emailjs from "emailjs-com";
import { useNotificationStore } from "@dafcoe/vue-notification";
let GetInTouch = class GetInTouch extends Vue {
    contact;
};
GetInTouch = __decorate([
    Options({
        props: {
            contact: String,
        },
        components: {},
        data() {
            return {
                isSendingMessage: false,
                from_name: "",
                from_email: "",
                subject: "",
                service: "",
                message: "",
            };
        },
        computed: {},
        methods: {
            resetForm() {
                const { setNotification } = useNotificationStore();
                setNotification({
                    message: "I have recieved your message, I will get back to you shortly! <br/><br/> Thank you!",
                    type: "info",
                    showIcon: false,
                    dismiss: {
                        manually: false,
                        automatically: true,
                    },
                    duration: 10000,
                    showDurationProgress: false,
                    appearance: "glass",
                });
            },
            // submitContactForm(e: any) {
            // 	e.preventDefault();
            // 	console.log(
            // 		"Contact Form Values: " + JSON.stringify(this.formVaues)
            // 	);
            // },
            sendEmail(e) {
                if (this.isSendingMessage !== undefined) {
                    this.isSendingMessage = true;
                }
                emailjs
                    .sendForm("service_ie326ym", "template_ubaz7gm", e.target, "user_IrTfpPFvy6mDHHWxN8eyN")
                    .then((result) => {
                    e.target.reset();
                    if (this.isSendingMessage !== undefined) {
                        this.isSendingMessage = false;
                    }
                    const { setNotification } = useNotificationStore();
                    setNotification({
                        message: "I have recieved your message, I will get back to you shortly! <br/> Thank you!",
                        type: "info",
                        showIcon: false,
                        dismiss: {
                            manually: false,
                            automatically: true,
                        },
                        duration: 10000,
                        showDurationProgress: false,
                        appearance: "glass",
                    });
                    console.log("SUCCESS!", result.status, result.text);
                    return;
                }, (error) => {
                    if (this.isSendingMessage !== undefined) {
                        this.isSendingMessage = false;
                    }
                    console.log("FAILED...", error);
                });
            },
        },
    })
], GetInTouch);
export default GetInTouch;
